export const BUS_EVENTS = {
  SET_TWEET_REPLY: 'SET_TWEET_REPLY',
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  TOGGLE_SIDEMENU: 'TOGGLE_SIDEMENU',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECTED: 'WEBSOCKET_RECONNECTED',
  INCOMING_MESSAGE_RECEIVED: 'INCOMING_MESSAGE_RECEIVED',
  // Copiloto IA: insere uma sugestão da aba lateral no compositor de resposta.
  SET_REPLY_EDITOR_MESSAGE: 'SET_REPLY_EDITOR_MESSAGE',
  // Copiloto IA: abre a aba do Copiloto (ex.: clique no chip de sentimento).
  OPEN_COPILOT: 'OPEN_COPILOT',
};
